import { render, staticRenderFns } from "./MonitorScoreExamDelete.vue?vue&type=template&id=50420e54&"
import script from "./MonitorScoreExamDelete.vue?vue&type=script&lang=js&"
export * from "./MonitorScoreExamDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports